import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './HeroSection.css';

function HeroSection() {
    return (
        <section id="home" className="hero-section">
            <Container>
                <Row className="align-items-center min-vh-100">
                    <Col lg={6} className="hero-content">
                        <div className="fade-in-up">
                            <h1 className="hero-title">
                                Trasformiamo <span className="gradient-text-alt">le tue Idee</span> in <span className="gradient-text-alt">Realtà Digitali</span>
                            </h1>
                            <h2 className="hero-subtitle">
                                BearSoftware - Sviluppo Software & Soluzioni Digitali
                            </h2>
                            <p className="hero-description">
                                Creiamo soluzioni software innovative e su misura per far crescere il tuo business.
                                Dal web development alle app mobile, dalla consulenza tecnica ai sistemi enterprise.
                            </p>
                            <div className="hero-buttons">
                                <a href="#services" className="btn-gradient">
                                    <span>Scopri i Servizi</span>
                                </a>
                                <a href="#contact" className="btn-outline">
                                    Richiedi Preventivo
                                </a>
                            </div>
                        </div>
                    </Col>
                    <Col lg={6} className="hero-image">
                        <div className="floating-card fade-in">
                            <div className="bear-logo-hero">
                                <img src="/logo-bear.png" alt="BearSoftware" className="pulse" />
                            </div>
                            <div className="card-tech">
                                <span><Link to="/digital-transformation" style={{textDecoration: 'none'}}>Digital Transformation</Link></span>
                                <span><Link to="/services/development/odoo" style={{textDecoration: 'none'}}>Odoo ERP/CRM — sviluppo & gestione</Link></span>
                                <span><Link to="/services/development/mobile-app-development" style={{textDecoration: 'none'}}>App Mobile iOS & Android</Link></span>
                                <span><Link to="/services/infrastructure/cloud-solutions" style={{textDecoration: 'none'}}>Cloud Solutions</Link></span>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
            <div className="hero-particles"></div>
        </section>
    );
}

export default HeroSection;